import React, { createContext, useContext, useEffect, useState } from 'react';
import { secureStorage } from '../utils/secureStorage';

interface ApiKeyContextType {
  apiKey: string | null;
  setApiKey: (key: string | null) => void;
  clearApiKey: () => void;
  isApiKeySet: boolean;
}

const ApiKeyContext = createContext<ApiKeyContextType | undefined>(undefined);

export function ApiKeyProvider({ children }: { children: React.ReactNode }) {
  const [apiKey, setApiKeyState] = useState<string | null>(null);

  useEffect(() => {
    // Carregar API key da sessão atual (não persistente entre sessões)
    const savedApiKey = secureStorage.getItem('api_key');
    if (savedApiKey) {
      setApiKeyState(savedApiKey);
    }
  }, []);

  const setApiKey = (key: string | null) => {
    setApiKeyState(key);
    if (key) {
      secureStorage.setItem('api_key', key);
    } else {
      secureStorage.removeItem('api_key');
    }
  };

  const clearApiKey = () => {
    setApiKeyState(null);
    secureStorage.removeItem('api_key');
  };

  const isApiKeySet = Boolean(apiKey);

  const value: ApiKeyContextType = {
    apiKey,
    setApiKey,
    clearApiKey,
    isApiKeySet,
  };

  return (
    <ApiKeyContext.Provider value={value}>{children}</ApiKeyContext.Provider>
  );
}

export function useApiKey(): ApiKeyContextType {
  const context = useContext(ApiKeyContext);
  if (context === undefined) {
    throw new Error('useApiKey must be used within an ApiKeyProvider');
  }
  return context;
}
